import React, { useContext } from 'react';

import AuthContext from '../contexts/AuthContext';
import PageContext from '../contexts/PageContext';

import { 
  Box, SwipeableDrawer, List, Divider, IconButton,
  ListItem, ListItemButton, ListItemIcon, ListItemText
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Assignment';
import ProfileIcon from '@mui/icons-material/AccountCircle';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import CalendarIcon from '@mui/icons-material/Today';
import TrashIcon from '@mui/icons-material/Delete';

export default function Drawer(props = {}) {
  const authContext = useContext(AuthContext);
  const pageContext = useContext(PageContext);

  const anchor = 'left';

  const [state, setState] = React.useState({
    left: false
  });

  const toggleDrawer = (open) => (event) => {
    if (
      event && 
      event.type === 'keydown' && 
      (event.key === 'Tab' || event.key === 'Shift') ||
      !authContext.isLoggedIn
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = () => (
    <Box
      sx={{ width: 'auto' }}
      role='presentation'
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem key={'Home'} disablePadding>
          <ListItemButton onClick={pageContext.onSetOrders}>
            <ListItemIcon>
              <HomeIcon/>
            </ListItemIcon>
            <ListItemText primary={'Inicio'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'Profile'} disablePadding>
          <ListItemButton onClick={pageContext.onSetProfile}>
            <ListItemIcon>
              <ProfileIcon/>
            </ListItemIcon>
            <ListItemText primary={'Perfil'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'Inbox'} disablePadding>
          <ListItemButton onClick={pageContext.onSetInbox}>
            <ListItemIcon>
              <InboxIcon/>
            </ListItemIcon>
            <ListItemText primary={'Recibidos'} />
          </ListItemButton>
        </ListItem>
        <ListItem key={'Trash'} disablePadding>
          <ListItemButton onClick={pageContext.onSetTrash}>
            <ListItemIcon>
              <TrashIcon/>
            </ListItemIcon>
            <ListItemText primary={'Papelera'} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List>
        <ListItem key={'Calendar'} disablePadding>
          <ListItemButton onClick={pageContext.onSetCalendar}>
            <ListItemIcon>
              <CalendarIcon/> 
            </ListItemIcon>
            <ListItemText primary={'Calendar'} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <React.Fragment key={anchor}>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        sx={{ mr: 2 }}
        onClick={toggleDrawer(true)}
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        anchor={anchor}
        open={state[anchor]}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        {list(anchor)}
      </SwipeableDrawer>
    </React.Fragment>
  );
}
